import { render } from "./dateFilter.vue?vue&type=template&id=32633d57&scoped=true&ts=true"
import script from "./dateFilter.vue?vue&type=script&lang=ts"
export * from "./dateFilter.vue?vue&type=script&lang=ts"

import "./dateFilter.vue?vue&type=style&index=0&id=32633d57&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32633d57"]])

export default __exports__